export default {"src":"/_next/static/media/add.546bdfec.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};